<template>
    <v-list 
        id="offline-norfield-nav-list-items"
    >
        <v-menu
            v-for="item in items"
            :key="item.title"
            bottom
            dark
            nudge-right="10"
            content-class="nav-bar-menu"
            offset-x
            :disabled="!(navbarMini && item.items.length)"
        >
            <template #activator="{ on: onMenu }">
                <v-tooltip 
                    right
                    color="#34383f"
                    :disabled="!navbarMini"
                >
                    <template #activator="{ on: onTooltip }">
                        <div 
                            :class="{ 'show-active-bar': isActiveNavListGroup(item.title.toLowerCase()) }"
                            @click.stop.prevent
                        >
                            <v-list-group
                                no-action
                                :group="item.title.toLowerCase()"
                                :disabled="!isActiveNavListGroup(item.title.toLowerCase())"
                                color="#fff"
                                :append-icon="item.items.length ? 'expand_more' : ''"
                                v-on="{ ...onMenu, ...onTooltip }"
                                @click.stop.prevent="gotoListGroupRoute(item.to)"
                            >
                                <v-icon
                                    slot="prependIcon"
                                    class="material-icons-outlined"
                                >
                                    {{ item.icon }}
                                </v-icon>
                                <template 
                                    v-slot:activator
                                >
                                    <v-list-item-content>
                                        <v-list-item-title v-text="item.title" />
                                    </v-list-item-content>
                                </template>
                            </v-list-group>
                            <div class="list-group-active-bar" />
                        </div>
                    </template>
                    <span v-if="isActiveNavListGroup(item.title.toLowerCase())">{{ item.title }}</span>
                    <span v-else>You are currently offline</span>
                </v-tooltip>
            </template>
        </v-menu>
    </v-list>
</template>

<script>
import { getNavigationItems } from '../../services/navigationRBAC'; 

export default {
    computed: {
        items() {
            return getNavigationItems(this.user.ingroup || '');
        },
        user() {
            return this.$store.getters.user;
        },
        navbarMini() {
            return this.$store.getters.navbarMini;
        },
    },
    methods: {
        outerClick() {
            console.log('click active bar div');
        },
        isNavListGroupRoot(path) {
            // If a navigationItem is found with the to value equal to the path
            // then it is NOT a Nav List Group Root.
            return !(this.items.find(nav => nav.to === path) || false);
        },
        isActiveNavListGroup(path) {
            return this.isNavListGroupRoot(path) 
                && this.$route.path.includes(path);
        },
        // This function is needed because v-list-group does not support
        // the 'to' navigation property that v-list-item supports.
        gotoListGroupRoute(to) {
            if(this.isActiveNavListGroup(to)) {
                this.$router.push(to);
            }
        }
    },
};
</script>
<style>
#offline-norfield-nav-list-items .v-list-group.v-list-group--disabled .theme--dark.v-list-item,
#offline-norfield-nav-list-items .v-list-group.v-list-group--disabled .theme--dark.v-list-item i,
#offline-norfield-nav-list-items .v-list-group.v-list-group--disabled .theme--dark.v-list-item .theme--dark.v-icon {
    color: #C5D5EC!important;
}
.v-list-item--active .active-bar
 {
    border-radius: 10px;
    width: 4px;
    background-color: #F26227;
    margin-left: 8px;
    height: 20px;
    left: 0px;
    position: absolute;
    clip: auto;
}
/* expanded navdrawer submenu items need their active-bar positioned differently 
than those of the pop out menus */
#offline-norfield-nav-list-items .v-list-group__items .v-list-item--active .active-bar {
    margin-left:-8px;
    left:auto;
}
#offline-norfield-nav-list-items .show-active-bar {
    position:relative;
}
#offline-norfield-nav-list-items .show-active-bar .list-group-active-bar
{
    border-radius: 10px;
    width: 4px;
    background-color: #F26227;
    margin-left: 8px;
    height: 20px;
    left: 0px;
    position: absolute;
    top: 18px;
} 
#offline-norfield-nav-list-items .v-list-item__title {
    font-size:14px;
}
.nav-bar-menu .theme--dark.v-list{
    background-color: #122448;
}
</style>